/**
 * th_saas answers 403 `{ Code: "UserAccessSuspended" }` to any request once the
 * caller's membership in the selected tenant is suspended or deactivated
 * (UC-084.3 E2). The API client reports it here and the layout's dialog
 * listens: access is off in this tenant, the session itself is fine.
 */
export const ACCESS_SUSPENDED_CODE = 'UserAccessSuspended'

type AccessSuspendedListener = () => void

const listeners = new Set<AccessSuspendedListener>()

export function onAccessSuspended(listener: AccessSuspendedListener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function notifyAccessSuspended(): void {
  listeners.forEach((listener) => listener())
}
